import api from "@/api.js";
import links from "./links/";
import keywords from "./keywords/";
import solutions from "./solutions/";

export default {
  namespaced: true,
  modules: {
    links,
    keywords,
    solutions,
  },
  state: {
    list: [],
    listLoading: false,
    selectedArticle: null,
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
    setSelectedArticle(state, payload) {
      state.selectedArticle = payload;
    },
  },
  actions: {
    async loadAll({ commit }) {
      commit("setListLoading", true);
      let list = await api.get("articles");
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadByID({ commit }, id) {
      commit("setListLoading", true);
      let list = await api.get("articles/byID", { params: { id: id } });
      commit("setSelectedArticle", list.data[0]);
      commit("setListLoading", false);
    },
    async loadByOutcomesID({ commit }, id) {
      commit("setListLoading", true);
      let list = await api.get("articles/byOutcomesID", { params: { id: id } });
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async new({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("articles", payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: err,
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async save({ dispatch }, payload) {
      let returnData = {};
      //Uploading Image
      if (payload.image) {
        let uploadImageResult = await api.post("articles/uploadImage", {
          id: payload.id,
          imageData: payload.image.dataUrl,
        });
        delete payload.image;
        if (uploadImageResult.data.Result == "Success") {
          payload.imageUrl = uploadImageResult.data.objectUrl;
        }
      }
      await api
        .put("articles", payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later",
            },
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async saveNoLoad({ dispatch }, payload) {
      let returnData = {};
      //Uploading Image
      if (payload.image) {
        let uploadImageResult = await api.post("articles/uploadImage", {
          id: payload.id,
          imageData: payload.image.dataUrl,
        });
        delete payload.image;
        if (uploadImageResult.data.Result == "Success") {
          payload.imageUrl = uploadImageResult.data.objectUrl;
        }
      }
      await api
        .put("articles", payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later",
            },
          };
        });
      return returnData;
    },
  },
  getters: {
    list(state) {
      return state.list;
    },
    listRecent(state) {
      return state.list.sort((a, b) => {
        return a.created_at > b.created_at ? -1 : 1;
      });
    },
    listLoading(state) {
      return state.listLoading;
    },
    selectedArticle(state) {
      return state.selectedArticle;
    },
  },
};
